
export enum PlayerStatusTypes {
  Ok = 1,
  Error = 2,
}
